import { render, staticRenderFns } from "./BookmarksSidebar.vue?vue&type=template&id=665c9fe8&scoped=true&"
import script from "./BookmarksSidebar.vue?vue&type=script&lang=js&"
export * from "./BookmarksSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BookmarksSidebar.vue?vue&type=style&index=0&id=665c9fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c9fe8",
  null
  
)

export default component.exports